import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "sm:px-4 lg:px-8" }
const _hoisted_3 = { class: "card sm:px-3 lg:px-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex flex-column lg:flex-row justify-content-center align-items-center text-center mb-4 pb-4 border-bottom-2 surface-border" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-4xl min-w-max" }, "VK Connect"),
  /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block text-4xl px-2" }, "-"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl sm:text-2xl lg:text-3xl" }, " сервис для чего то очень нужного ")
], -1)
const _hoisted_5 = { class: "flex flex-column md:flex-row justify-content-center align-items-center relative text-center mb-4 pb-4 border-bottom-2 surface-border" }
const _hoisted_6 = { class: "md:p-2 md:mb-0 mb-2 w-full" }
const _hoisted_7 = { class: "border-1 surface-border border-round py-3 shadow-3" }
const _hoisted_8 = { class: "font-bold text-base md:text-xl flex md:flex-column align-items-center justify-content-center" }
const _hoisted_9 = { class: "md:mt-3 mb-0 ml-2 md:ml-0 pr-3 md:pr-0 text-red-600 text-xl md:text-3xl" }
const _hoisted_10 = { class: "md:p-2 md:mb-0 mb-2 w-full" }
const _hoisted_11 = { class: "border-1 surface-border border-round py-3 shadow-3" }
const _hoisted_12 = { class: "font-bold text-base md:text-xl flex md:flex-column align-items-center justify-content-center" }
const _hoisted_13 = { class: "md:mt-3 mb-0 ml-2 md:ml-0 pr-3 md:pr-0 text-green-600 text-xl md:text-3xl" }
const _hoisted_14 = { class: "md:p-2 md:mb-0 mb-2 w-full" }
const _hoisted_15 = { class: "border-1 surface-border border-round py-3 shadow-3" }
const _hoisted_16 = { class: "font-bold text-base md:text-xl flex md:flex-column align-items-center justify-content-center" }
const _hoisted_17 = { class: "md:mt-3 mb-0 ml-2 md:ml-0 pr-3 md:pr-0 text-blue-600 text-xl md:text-3xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(" Всего пользователей: "),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.usersCount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(" Активных пользователей: "),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.activeUsersCount), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(" Функций включено: "),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.activeFunctionsCount), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}